
/**
 * Interface for the response of the user registration API.
 */
export interface RegisterUserResponse {
  travelerType:   TripTypeResponse[];
  categories:     CategoryResponse[];
  subCategories?:  any[]; // TODO: EN EMT NO HAY SUBCATEGORIES
  registerBefore: boolean | null; // TODO: IDK
  provinces:      Province[];
  countries:      Country[];
  location:       RegisterUserLocation;
  pointListLoader: PointLoader[];
}

export interface TripTypeResponse {
  id:        number;
  name:      TravelerTypeName;
  client_id: string;
  image:     string;
  icon:      string | null;
}

export interface CategoryResponse {
  id:            number;
  name:          CategoryName;
  client_id:     string;
  image:         string;
  subCategories: any[];
  sections_app:  string[] | null;
  icon:          string | null;
}

export type TravelerTypeName = Name;
export type CategoryName = Name;
export type PointLoaderName = Name;
type Name = Record<string, string>;

export interface Country {
  id:         number;
  name:       string;
  iata:       string;
  created_at: Date;
  updated_at: Date;
}

export interface Province {
  id:      number;
  name:    string;
  region:  string;
  name_es: string;
}

export interface RegisterUserLocation {
  lat: number;
  lng: number;
  address: string;
}

export interface PointLoader {
  id: number;
  name: PointLoaderName;
  src: string;
}

export interface MovilityType {
  value: string;
  name: string;
}

export interface TripType {
  id: number;
  value: number;
  label: string;
  iconName: string;
}

export interface Interest {
  id: number;
  label: string;
  value: number;
  iconName: string;
}

export interface TransportMean {
  id: number;
  label: string;
  value: string;
  iconName: TransportMeanIconName;
  eco: boolean;
}

export type TransportMeanIconName = keyof typeof TransportMeanIconNameMap;

export const TransportMeanIconNameMap = { // ? NOT SURE THE NAME OF ALL THE TYPES
  walk: 'walk',
  bike: 'bike',
  'bus-interurbano': 'bus-interurbano',
  'bus-emt': 'bus-emt',
  metro: 'metro',
  'metro-ligero': 'metro-ligero',
  cercanias: 'cercanias',
} as const;

export interface SendRegisterUserResponse {
  status: number;
  message: string;
  token: string;
  alternativeRoute: boolean;
  totalDays: number;

}
